/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

import { SecureTokenContextModel } from 'api/onboarding/getSecureTokenData.schemas';
import { NetworkListEntry } from 'api/network/queryRelationships/index.schemas';


const acceptVccTerms = createApiAction({
  method: 'post',
  url: '/api/landing/acceptVccTerms',
  requestBodyMapper: ({
    secureToken,
    addressBookId
  }) => ({
    secureToken,
    addressBookId
  }),
  markUpdated: {
    entityTypes: [
      SecureTokenContextModel.meta.name,
      NetworkListEntry.meta.name
    ]
  }
});

export default acceptVccTerms;